import { rootLogger } from '../components/useLog/useLog';

// AbortSignal.timeout() is a relatively recent addition to browsers,
// and it throws an error on browsers that do not support this method.
// This mehod provide a fallback that manually aborts via setTimeout.
export const createAbortTimeoutSignal = (milliseconds) => {
  if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') {
    return {
      signal: AbortSignal.timeout(milliseconds),
      clearAbortTimeOut: () => {},
    };
  }
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), milliseconds);
  controller.signal.addEventListener('abort', () => clearTimeout(timer));
  const clearAbortTimeOut = () => {
    clearTimeout(timer);
  };
  return { signal: controller.signal, clearAbortTimeOut };
};

export async function getToken(
  encryptedCardNumber,
  cardExpiryMonth,
  cardExpiryYear,
  pxpConfig,
) {
  let pxpToken;
  const {
    pxpTokenUrl,
    timeout = 10000,
    publicApiKey,
    publicEncryptionKey,
    encryptionType = 'rsaTwoFourZeroEight',
    pxpMerchantID,
  } = pxpConfig || {};
  if (!pxpTokenUrl || !publicApiKey || !publicEncryptionKey?.id || !pxpMerchantID) {
    rootLogger.logger('getToken').warn('Config incomplete', JSON.stringify({
      pxpTokenUrl,
      publicApiKey,
      publicEncryptionKey,
      pxpMerchantID,
    })).destroy();
    return pxpToken;
  }
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `PublicApiKey ${publicApiKey}`,
  };

  const { signal, clearAbortTimeOut } = createAbortTimeoutSignal(timeout);
  const body = JSON.stringify({
    details: {
      cardExpiryMonth,
      cardExpiryYear,
      cardNumber: encryptedCardNumber,
    },
    encryptionDetails: {
      encryptionType,
      encryptionId: publicEncryptionKey?.id,
    },
    merchantId: pxpMerchantID,
  });
  try {
    const response = await fetch(
      pxpTokenUrl,
      {
        method: 'POST',
        headers,
        body,
        signal,
      },
    );
    if (response?.ok) {
      const data = await response.json();
      if (data && data?.State?.trim()?.toLowerCase() === 'approved') {
        pxpToken = data?.Id;
      }
    } else {
      rootLogger.logger('getToken').error('ERROR', JSON.stringify(response)).destroy();
    }
  } catch (err) {
    rootLogger.logger('getToken').error('ERROR', err?.message).destroy();
  } finally {
    clearAbortTimeOut();
  }
  return pxpToken;
}
